import { type IncidentDto, IncidentSeverity, IncidentStatus } from '@api/incidents';

export function getRuleIncidentCountBySeverity(incidents: IncidentDto[]) {
  return incidents
    .filter(incident => incident.status !== IncidentStatus.RESOLVED)
    .reduce(
      (incidentCountBySeverity, incident) => ({
        ...incidentCountBySeverity,
        [incident.severity]: incidentCountBySeverity[incident.severity] + 1,
      }),
      {
        [IncidentSeverity.CRITICAL]: 0,
        [IncidentSeverity.MAJOR]: 0,
        [IncidentSeverity.MINOR]: 0,
      },
    );
}
